import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder, AbstractControl, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../../../../app.config';
import { MessageService } from 'primeng/api';
import { RegistrationService } from '../../../../services/registration.service';
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-wizard-link-pos',
  templateUrl: './wizard-link-pos.component.html',
  styleUrls: ['./wizard-link-pos.component.scss']
})
export class WizardLinkPosComponent implements OnInit {

  @Input() messageService : MessageService;
  @Input() verificationCode;
  @Input() partner;
  @Output() next = new EventEmitter();
  public loading = true;
  public message = null;  
  public POSSytems = []
  public selectPOS : any = {};
  public creatingDummyData : boolean = false;

  constructor(
    private appConfig : AppConfig,
    private fb: FormBuilder,
    private translate: TranslateService,
    private registrationService : RegistrationService,
    public router: Router,
  ) { }

  ngOnInit() {    
    this.POSSytems = this.appConfig.getSupportedPOSSystems();
    if(!this.partner || !this.partner.PartnerID){
      this.registrationService.verifyAccount(this.verificationCode).subscribe(partner=>{
        this.partner = partner;     
        this.setSelectedPOS();
        this.loading = false;
      },err=>{
        this.message = this.translate.instant('onboarding.messages.verification_failed');
        this.loading = false;
      });
    }else{ 
      this.loading = false;
      this.setSelectedPOS();
    }
  }

  setSelectedPOS(){
    this.selectPOS = this.POSSytems.filter(pos => { return pos.POSID === this.partner.POSSystemID })[0];
    console.log(this.selectPOS);
  }

  done(event){
    this.skipToHubtiger();
  }


  skipToHubtiger() {
    this.creatingDummyData = true;
    this.registrationService.generateDummyData(this.verificationCode, {PartnerID : this.partner.PartnerID}).subscribe(result=>{
      this.creatingDummyData = false;
      this.router.navigateByUrl("/store/calendar");
    },err=>{
      this.creatingDummyData = false;
      this.router.navigateByUrl("/store/calendar");
    });
    
  }

}
